import React from "react";
import { Box, Fab } from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router";
import NavigationSVG from "../../../../media/svg/NavigationSVG";

const TermsHeader = () => {
  // const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();

  const handleClickMenu = (e) => {
    e.stopPropagation();
    // setAnchorEl(e.currentTarget);
  };

  const handlePrevPage = (e) => {
    e.stopPropagation();
    navigate(-1);
  };

  return (
    <Box
      sx={{
        display: "flex",
        position: "fixed",
        top: "0",
        width: "calc(100% - 32px)",
        justifyContent: "space-between",
        alignItems: "center",
        paddingY: "16px",
        zIndex: 2,
      }}
    >
      <Fab
        onClick={handlePrevPage}
        sx={{
          border: "2px solid",
          borderColor: "black.main",
          backgroundColor: "white.main",
          color: "black.main",
          pr: "2px",
          boxShadow: "none",
          "&.MuiButtonBase-root:hover": {
            boxShadow: "none",
            border: "none",
          },
          "&.MuiButtonBase-root:active": {
            backgroundColor: "black.main",
            boxShadow: "none",
            color: "white.main",
            border: "none",
          },
        }}
        size='medium'
        aria-label='back'
      >
        <ArrowBackIosNewRoundedIcon sx={{ fontSize: "32px" }} />
      </Fab>
      <Typography
        sx={{
          Height: "32px",
          fontSize: "20px",
        }}
      >
        Terms & Conditions
      </Typography>
      <Fab
        onClick={handleClickMenu}
        sx={{
          border: "2px solid",
          borderColor: "black.main",
          backgroundColor: "white.main",
          color: "black.main",
          boxShadow: "none",
          "&.MuiButtonBase-root:hover": {
            boxShadow: "none",
            border: "none",
          },
          "&.MuiButtonBase-root:active": {
            backgroundColor: "black.main",
            boxShadow: "none",
            color: "white.main",
            border: "none",
          },
        }}
        size='medium'
        aria-label='more'
      >
        {/* <MoreVertIcon sx={{ fontSize: "32px" }} /> */}
        <NavigationSVG />
      </Fab>
      {/* <MenuNavbar anchorEl={anchorEl} setAnchorEl={setAnchorEl} /> */}
    </Box>
  );
};

export default TermsHeader;
